export type MemberId = 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

const FULL_SCORE = 5;

export class Group {
  private _answers: MemberId[] = [];

  constructor(public readonly name: string, public readonly members: MemberId[]) {
    // No process
  }

  public get answers() { return this._answers; }

  public add(member: MemberId) {
    this._answers.push(member);
  }

  public remove(member: MemberId) {
    this._answers = this._answers.filter(v => v !== member);
  }

  public get addedCount(): number {
    return this._answers.length;
  }

  public get isFull(): boolean {
    return this._answers.length === this.members.length;
  }

  public isCollect(answers: MemberId[]): boolean {
    if (this.members.length !== answers.length) {
      return false;
    }
    return answers.every(v => this.members.indexOf(v) !== -1);
  }

  public reset() {
    this._answers = [];
  }

  public isAdded(memberId: MemberId): boolean {
    return this._answers.includes(memberId);
  }
}

export class Question {
  constructor(
    public readonly title: string,
    public readonly lylics: string,
    public readonly groups: Group[],
  ) {
    // No process
  }

  public get score(): number {
    const groups = this.groups;
    let result = 0;
    groups.forEach(g => {
      groups.forEach(a => {
        if (g.isCollect(a.answers)) {
          result++;
        }
      });
    });
    return result === groups.length ? FULL_SCORE : result;
  }

  public get addedCount(): number {
    return this.groups.map(v => v.addedCount).reduce((a, b) => a + b, 0);
  }

  public get isFull(): boolean {
    return this.groups.every(v => v.isFull);
  }

  public isAdded(memberId: MemberId): boolean {
    return this.groups.some(v => v.isAdded(memberId));
  }

  public add(memberId: MemberId): void {
    const group = this.groups.find(v => !v.isFull);
    if (group) {
      group.add(memberId);
    }
  }

  public remove(memberId: MemberId): void {
    this.groups.forEach(v => v.remove(memberId));
  }
}
